import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Address } from "../../../../core/models/shared/address";
import { VendorSummaryDto } from "../../../../core/models/vendor/summary/vendorSummaryDto";
import { LoaderService } from "../../../../core/services/loader.service";
import { DrawerModule } from "primeng/drawer";
import { CommonModule } from "@angular/common";
import { VendorService } from "../../../../core/services/vendor.service";

@UntilDestroy()
@Component({
  selector: "jni-view-address-information",
  templateUrl: "./view-address-information.component.html",
  styleUrls: ["./view-address-information.component.scss"],
  encapsulation: ViewEncapsulation.None,
  imports: [DrawerModule, CommonModule],
})
export class ViewAddressInformationComponent implements OnInit {
  @Input() display!: boolean;
  @Output() displayChange = new EventEmitter<boolean>();
  vendorStatusId = "";
  vendorAddressInformation?: Address[];
  vendorInformation?: VendorSummaryDto;
  @Output() editEvent = new EventEmitter<Address>();
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input("vendorIdFromModal")
  set vendorIdFromModal(value: string) {
    this.vendorStatusId = value;
  }
  // eslint-enable-next-line @angular-eslint/no-input-rename

  constructor(
    private _vendorService: VendorService,
    private router: ActivatedRoute,
    public _loaderService: LoaderService
  ) {
    this.router.params.subscribe(params => {
      this.vendorStatusId = params["id"];
    });
  }

  ngOnInit(): void {
    this.getVendorInformationData();
  }

  onHide() {
    this.displayChange.emit(false);
  }

  openEditAddress(event: Address) {
    this.editEvent.emit(event);
  }

  getVendorInformationData() {
    if (this.vendorStatusId) {
      this._loaderService.setLoaderState(true);
      this._vendorService
        .getVendorInformation(this.vendorStatusId?.toString())
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.vendorInformation = res.data;
            if (this.vendorInformation?.addresses) {
              this.vendorAddressInformation = this.vendorInformation?.addresses;
            }

            this._loaderService.setLoaderState(false);
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }
}
